export default "__VITE_ASSET__BQIHOZcS__"